import { render, staticRenderFns } from "./materialsList.vue?vue&type=template&id=320a8b9a&"
import script from "./materialsList.vue?vue&type=script&lang=js&"
export * from "./materialsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports